// import {EventEmitter} from 'fbemitter';
import {observable, computed, action, makeObservable} from 'mobx';
import {checkout} from '../api';
import {getCookieValue, Portal} from '../util';

declare var __preload_checkout: ICheckoutObject | null;
declare var __checkout_ab_skip: number;

export class AppStore {
    // emitter: EventEmitter;
    @observable checkout: ICheckoutObject;
    @observable uiCheckout: ICheckoutUI;
    @observable dd: string;
    @observable debug: boolean = false;
    @observable reset_payment: boolean = false;
    @observable errorLog: string;
    @observable errorLogInfo: string;
    @observable apiError: boolean = false;
    @observable payment_type: string = '';

    @observable payment_allow_apple = false;
    @observable payment_allow_card = false;
    @observable payment_allow_google = false;
    @observable payment_allow_paypalCredit = false;
    @observable payment_allow_paypal = false;
    @observable payment_allow_venmo = false;

    @observable payment_option_selected = false;
    @observable payment_submitted = false;

    @observable places_throttle: any;
    @observable places_timer: number = 0;
    @observable places_start: Date;
    @observable places_end: Date;
    @observable debugText: any;
    @observable ab: any;
    @observable checkoutABSkip: number = 0;
    @observable performedSkip: boolean = false;

    checkoutReloadPayment: () => void;
    checkoutRefreshCS: () => void;

    constructor() {
        this.uiCheckout = {
            isLoadingCart: false,
            isLoadingEstimated: false,
            isSelectingPaymentMethod: false,
            processing: false,
            isSpecialProcessing: false,
            stateRequiredShip: true,
            stateRequiredBilling: true,
            loadingCoord: false,
            coord: [],
            requireReset: false,
            newCheckout: true,
        };
        this.checkoutReloadPayment = this.checkoutReloadPayment;
        this.checkoutRefreshCS = this.blankFunction;
        this.initCheckout();
        makeObservable(this);
    }

    @action
    initCheckout = () => {
        this.getPortalSettings();
        this.checkoutABSkip = __checkout_ab_skip;
        if (typeof __preload_checkout !== 'undefined' && __preload_checkout !== null) {
            this.checkout = JSON.parse(JSON.stringify(__preload_checkout)) as ICheckoutObject;
            if (this.checkout.ship == undefined) {
                this.checkout.ship = this.getEmptyShipping();
            }
            if (this.checkout.billing == undefined) {
                this.checkout.billing = this.getEmptyBilling();
            }
            if (this.checkout.cart == undefined) {
                this.checkout.cart = this.getEmptyCart();
            }
            // console.log('preloaded');
        } else {
            this.freshCheckout();
        }

        // apple
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        try {
            if (window.ApplePaySession) {
                this.payment_allow_apple = true;
            }
        } catch (ex4) {
            console.error(ex4);
        }
    };

    @action
    getPortalSettings = () => {
        if (Portal?.PortalID === 3) {
            Portal.CustomerServicePhone = '475-444-0223';
        }
    };

    @action
    freshCheckout = () => {
        this.checkout = {
            cstep: ICheckoutStep.cart,
            isMyFrames: false,
            isAuthenticated: false,
            email: this.getFormInput('Email', 'email', 3, 100),
            phone: this.getFormInput('Phone Number', 'tel', 10, 20),
            pwd: this.getFormInput('Password', 'current-password', 1, 50),
            optIn: true,
            createAccount: false,
            messages: [],
            cart: this.getEmptyCart(),
            ship: this.getEmptyShipping(),
            billing: this.getEmptyBilling(),
            CheckoutType: ICheckoutType.normal,
            force_normal_checkout: false,
            missing_shipping_info: false,
            missing_shipping_info_warning: false,
            discount_code: null,
            paypal_order: {},
            paypal_order_init: {},
            stripe_express_order: {
                dataRaw: '',
                tokenRaw: '',
                token: '',
                email: '',
                tranType: '',
                methodName: '',
                payerEmail: '',
                payerName: '',
                payerPhone: '',
                shippingAddress: {},
                billingAddress: {},
                shippingOption: {},
                displayedCharge: -1,
            },
            notes_customer: '',
            notes_gift: '',
            code_gift: this.getFormInput('Gift Code', '', 16, 20),
            code_promo: this.getFormInput('Promo Code', '', 1, 50),
            code_gift_applied: false,
            code_promo_applied: false,
            code_promo_type: ISpecialDiscountCodeType.normal,
            code_promo_shipping_text: '',
            code_promo_text: '',
            giftMessageId: 7,
            ab: 1,
            ab_1: 0,
            ab_2: 0,
            received_fast_ship_warning: false,
            is_fast_shipping: false,
            is_fast_shipping_broken: false,
            UseShop: false,
            UseShopForce: false,
            giftMessages: [
                {
                    GiftMessageID: 1,
                    GiftMessage: 'Congratulations and Best Wishes on Your Graduation!',
                    Name: 'Best Wishes on Your Graduation',
                },
                {
                    GiftMessageID: 2,
                    GiftMessage: 'Congratulations on your success - may the future bring even more!',
                    Name: 'Congratulations',
                },
                {
                    GiftMessageID: 3,
                    GiftMessage: 'Wishing You A Very Merry Christmas!',
                    Name: 'Merry Christmas',
                },
                {
                    GiftMessageID: 4,
                    GiftMessage: 'During the Festival of Lights - May happiness and love brighten your home. Best Wishes at Hanukkah!',
                    Name: 'Happy Hanukkah',
                },
                {
                    GiftMessageID: 5,
                    GiftMessage: 'Best Wishes for a Very Happy Birthday!',
                    Name: 'Happy Birthday',
                },
                {
                    GiftMessageID: 6,
                    GiftMessage: 'Happy Memories...Happy Moments...Happy Anniversary!',
                    Name: 'Happy Anniversary',
                },
                {
                    GiftMessageID: 7,
                    GiftMessage: '',
                    Name: ' Write my own message',
                },
            ],
            msg_shipping_special: '',
            myframes_isDropShip: true,
            myframes_po: this.getFormInput('PO Number', '', 1, 100),
            myframes_email: '',
            myframes_phone: '',
            AddressBookAddresses: [],
            payment_type: '',
            fbc: '',
            fbp: '',
        };
        this.checkout.ship.addr.country.value = 'US';
        this.checkout.billing.addr.country.value = 'US';
        this.setFB();
    };

    @action
    getEmptyCart = (): ICart => ({
        hasBackOrder: false,
        messages: [],
        items: [],
        pricing: {
            subtotal: 0,
            subtotal_nogifts: 0,
            shipping: 0,
            production: 0,
            tax: 0,
            total: 0,
            discount: 0,
            discount_shipping: 0,
            gift: 0,
            isEstShipping: true,
            isEstTaxes: true,
        },
        cartId: -1,
    });

    @action
    getEmptyShipping = (): ICheckoutShipping => ({
        addr: this.getEmptyAddr(true),
        addressType: ICheckoutAddressType.home,
        corr: this.getEmptyAddr(true),
        correctionAvailable: false,
        ignoreCorrection: false,
        messages: [],
        estimatedPostalCode: '',
        shipMethod: {
            dates: '',
            desc: '',
            price: '',
            prodMethodId: 0,
            shipMethodId: 0,
            key: -1,
            price_production: 0,
            price_shipping: 0,
            isSuperSaver: false,
            SuperSaverDiscount: 0,
        },
        shipOptions: [],
        shipDays: 5,
        geoloc: {
            ip: '',
            city: '',
            region: '',
            region_code: '',
            country: '',
            country_name: '',
            postal: '',
            latitude: 0,
            longitude: 0,
            timezone: '',
            asn: '',
            org: '',
            stateCode: '',
        },
        google_autocomplete: [],
        google_autocomplete_details: [],
        google_autocomplete_placeid: '',
        AddressID: -1,
    });

    @action
    getEmptyBilling = (): ICheckoutBilling => ({
        ccNumber: this.getFormInput('', 'cc-number'),
        ccExp: this.getFormInput('MM/YY', 'cc-exp'),
        ccCSC: this.getFormInput('XXX', 'cc-csc', 3, 4),
        messages: [],
        msg_ccCSC: '',
        msg_ccExp: '',
        msg_ccNumber: '',
        addrSameAsShip: false,
        addr: this.getEmptyAddr(false),
        paymentError: '',
        ccType: ICreditCardType.Other,
        ccTypeName: '',
        AddressID: -1,
    });

    @action
    getEmptyAddr = (isShipping: boolean): IAddress => {
        const pf = isShipping ? 'shipping' : 'billing';
        return {
            firstName: this.getFormInput('First Name', `${pf} given-name`, 2, 50),
            lastName: this.getFormInput('Last Name', `${pf} family-name`, 2, 50),
            companyName: this.getFormInput('Company Name', `${pf} organization`, 1, 100),
            address1: this.getFormInput('Address', `${pf} address-line1`, 2, 100),
            address2: this.getFormInput('Address Line 2', `${pf} address-line2`, 2, 100),
            address3: this.getFormInput('Address Line 3', `${pf} address-line3`, 2, 100),
            address4: this.getFormInput('Address Line 4', `${pf} address-line4`, 2, 100),
            city: this.getFormInput('City', `${pf} address-level2`, 2, 50),
            state: this.getFormInput('State', `${pf} address-level1`, 2, 50),
            postalCode: this.getFormInput('Postal Code', `${pf} postal-code`, 5, 20),
            country: this.getFormInput('Country', `${pf} country`, 2, 2),
            addrShowMore: false,
            addrShowMoreCompany: false,
            isBusinessAddress: false,
        };
    };

    // tslint:disable-next-line
    @computed get getTotal() {
        let _total = store.checkout.cart.pricing.subtotal - store.checkout.cart.pricing.discount - store.checkout.cart.pricing.discount_shipping;
        _total = _total - store.checkout.cart.pricing.gift + store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production + store.checkout.cart.pricing.tax;
        if (_total < 0) {
            _total = 0;
        }
        return _total;
    }

    getFormInput = (_ph: string = '', _ac: string = '', _min: number = 0, _max: number = 100, _rgx: string = ''): IFormInput => ({
        value: '',
        placeholder: _ph,
        autocomplete: _ac,
        valid: this.getInputValidation(_rgx, _min, _max),
    });

    getInputValidation = (_rgx: string, _min: number, _max: number): IValidationObject => ({
        msg: '',
        isError: false,
        alive: false,
        rgx: _rgx,
        rgx_msg: '',
        minLength: _min,
        maxLength: _max,
    });

    @action
    checkoutSetTestData() {
        this.checkout.ship.addressType = ICheckoutAddressType.home;
        this.checkout.ship.addr.address1.value = '469 N. Crescent Dr.';
        this.checkout.ship.addr.firstName.value = 'Luo';
        this.checkout.ship.addr.lastName.value = 'Ji';
        this.checkout.ship.addr.city.value = 'Beverly Hills';
        this.checkout.ship.addr.state.value = 'CA';
        this.checkout.ship.addr.country.value = 'US';
        this.checkout.ship.addr.postalCode.value = '90210';
        this.checkout.email.value = 'test@test.com';
        this.checkout.phone.value = '5555555555';
        this.checkout.billing.addrSameAsShip = false;
        this.checkout.billing.ccNumber.value = '4111111111111111';
        this.checkout.billing.ccExp.value = '12/20';
        this.checkout.billing.ccCSC.value = '999';
        this.checkout.billing.addr.address1.value = '469 N. Crescent Dr.';
        this.checkout.billing.addr.firstName.value = 'Luo';
        this.checkout.billing.addr.lastName.value = 'Ji';
        this.checkout.billing.addr.city.value = 'Beverly Hills';
        this.checkout.billing.addr.state.value = 'CA';
        this.checkout.billing.addr.country.value = 'US';
        this.checkout.billing.addr.postalCode.value = '90210';
        this.checkout.code_gift.value = '';
        this.checkout.optIn = true;
    }

    @action
    moveStep = async (_cstep: ICheckoutStep) => {
        this.checkout.cstep = _cstep;
        // console.log(_cstep);
        // console.log(this.checkout.isAuthenticated);
        // console.log('new via client', this.checkout.cstep);
        if (this.checkout.cstep === ICheckoutStep.checkout && this.checkout.isAuthenticated) {
            if (this.checkout.isMyFrames) {
                this.checkout.cstep = ICheckoutStep.oci;
            }
        }

        if (this.uiCheckout.requireReset) {
            this.freshCheckout();
            this.uiCheckout.requireReset = false;
            const success = await checkout('reset-cart');
        } else {
            const success = await checkout('checkout-sync');
        }

        this.setFB();
    };

    @action
    setShippingAddressToBook = () => {
        if (store.checkout.ship.AddressID < 1) {
            return;
        }
        const addr = store.checkout.AddressBookAddresses.filter(x => x.AddressID === store.checkout.ship.AddressID);
        if (addr && addr.length > 0) {
            const a = addr[0];
            store.checkout.ship.addr.firstName.value = a.FirstName;
            store.checkout.ship.addr.lastName.value = a.LastName;
            store.checkout.ship.addr.address1.value = a.AddressLine1;
            store.checkout.ship.addr.address2.value = a.AddressLine2 ? a.AddressLine2 : '';
            store.checkout.ship.addr.city.value = a.City;
            store.checkout.ship.addr.state.value = a.State;
            store.checkout.ship.addr.country.value = a.Country;
            store.checkout.ship.addr.companyName.value = a.CompanyName ? a.CompanyName : '';
            store.checkout.ship.addr.postalCode.value = a.Zipcode;
            if (a.AddressLine2) {
                store.checkout.ship.addr.addrShowMore = true;
            } else {
                store.checkout.ship.addr.addrShowMore = false;
            }
            if (a.CompanyName) {
                store.checkout.ship.addr.addrShowMoreCompany = true;
            } else {
                store.checkout.ship.addr.addrShowMoreCompany = false;
            }
        }
    };

    @action
    setBillingAddressToBook = () => {
        if (store.checkout.billing.AddressID < 1) {
            return;
        }
        const addr = store.checkout.AddressBookAddresses.filter(x => x.AddressID === store.checkout.billing.AddressID);
        if (addr && addr.length > 0) {
            const a = addr[0];
            store.checkout.billing.addr.firstName.value = a.FirstName;
            store.checkout.billing.addr.lastName.value = a.LastName;
            store.checkout.billing.addr.address1.value = a.AddressLine1;
            store.checkout.billing.addr.address2.value = a.AddressLine2 ? a.AddressLine2 : '';
            store.checkout.billing.addr.city.value = a.City;
            store.checkout.billing.addr.state.value = a.State;
            store.checkout.billing.addr.country.value = a.Country;
            store.checkout.billing.addr.companyName.value = a.CompanyName ? a.CompanyName : '';
            store.checkout.billing.addr.postalCode.value = a.Zipcode;
            if (a.AddressLine2 || a.CompanyName) {
                store.checkout.billing.addr.addrShowMore = true;
                store.checkout.billing.addr.addrShowMoreCompany = true;
            } else {
                store.checkout.billing.addr.addrShowMore = false;
                store.checkout.billing.addr.addrShowMoreCompany = false;
            }
        }
    };

    @action
    setFB = () => {
        try {
            if (!store.checkout.fbc || store.checkout.fbc === '') {
                store.checkout.fbc = getCookieValue('_fbc');
            }
            if (!store.checkout.fbp || store.checkout.fbp === '') {
                store.checkout.fbp = getCookieValue('_fbp');
            }
        } catch (err_fb) {
            // do nothing
        }
    };

    blankFunction = () => {
        const x = 1;
    };
}

const store = new AppStore();
export default store;
